var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerVald = function SvgHamburgerVald(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 22,
    viewBox: "0 0 28 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 4,
    x: -1,
    y: 9,
    rx: 2,
    transform: "rotate(45 14 11)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 4,
    x: -1,
    y: 9,
    rx: 2,
    transform: "scale(-1 1)rotate(45 0 -22.799)"
  }))));
};
export default SvgHamburgerVald;